<div class="modal-header">
    <h2>{{ "COMPARE_SOLUTIONS" | translate }}</h2>
    <button type="button" class="close" (click)="dismissModal()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body h-100">
    @if (routeResult) {
        <div class="d-flex flex-row justify-content-center w-100 h-100">
            <app-route-comparison-solution (closeModal)="dismissModal()" [route]="routeResult[1]" [jobId]="jobId[1]"
                                           [isRideSharing]="true"
                                           [isRideSharingInRoute]="isRideSharingInRoute"></app-route-comparison-solution>
            <app-route-comparison-solution (closeModal)="dismissModal()" [route]="routeResult[0]" [jobId]="jobId[0]"
                                           [isRideSharing]="false"></app-route-comparison-solution>
        </div>
    }
</div>
